<template>
  <div v-if="loginState.isAuditor">
    <div class="row" v-if="loginState.isAdministrator">
      <div class="col-md-12">
        <b-button variant="primary" class="btn btn-primary float-right mb-1" v-on:click="add()">
        <i class="fa fa-plus"/>&nbsp;Skapa fordon
        </b-button>
      </div>
    </div>
    <b-card>
      <b-form-checkbox v-model="showInactiveBenefitVehicles" class="mb-1">
        Visa inaktiva fordon
      </b-form-checkbox>
      <div slot="header">
        Fordon
        <div class="card-header-actions">
        <b-spinner v-if="loading" class="mr-1" type="border" small />
        </div>
      </div>  

      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th class="w-25">Registreringsnummer</th>
            <th class="w-25">Brukare</th>
            <th class="w-25">Typ</th>
            <th class="w-25">Märke/modell</th>
          </tr>
        </thead>
      <tbody>
        <tr v-on:click="edit(benefitVehicle)" v-for="benefitVehicle in sortedBenefitVehicles" :key="benefitVehicle.id" style="cursor:pointer">
          <td>{{benefitVehicle.registrationNumber}}</td>
          <td>{{benefitVehicle.employeeName}}</td>
          <td>{{getVehicleType(benefitVehicle.vehicleType)}}</td>
          <td>{{benefitVehicle.brand}} {{benefitVehicle.model}} {{getFuelType(benefitVehicle.fuelType)}}</td>
        </tr>
      </tbody>
      </table>            
    </b-card>
  </div>
</template>

<script>
import { employeeService, userService } from "../../shared/services";
import { benefitVehicleService } from "../../shared/services/benefitVehicle.service"

export default {
  created() {
    this.loginState.init();
  }, 
  computed: {
    sortedBenefitVehicles() {
      if(!this.benefitVehicles) return [];
      return this.benefitVehicles.filter(f => f.isActive || this.showInactiveBenefitVehicles);
    },
    
  },    
  data() {
    return {
      loading: false,
      benefitVehicles: null,
      employees: [],
      selectedBenefitVehicle: null,
      showInactiveBenefitVehicles: false,
      vehicleTypes: [
        { id: 10, name: "Bil" },
        { id: 20, name: "Cykel" },
      ],
      fuelTypes: [
        { id: 10, name: "Ingen" },
        { id: 20, name: "Diesel" },
        { id: 30, name: "Bensin" },
        { id: 40, name: "Gas" },
        { id: 50, name: "Etanol" },
        { id: 60, name: "PlugInHybrid" },
      ],
    };
  },     
  async mounted() {
    await this.getVehicles();
  },
  methods: {
    async getVehicles() {
      this.loading = true;
      try {
        this.benefitVehicles = await benefitVehicleService.get();
      } catch {
        this.ShowToast("Fel", "Ett okänt fel uppstod då fordon skulle hämtas", "danger")
      }
      this.loading = false;
    },
    add: function() {
      this.$router.push({ path: `/administration/benefitvehicles/0` });
    },    
    edit: function(benefitVehicle) {
      this.$router.push({ path: `/administration/benefitvehicles/${benefitVehicle.registrationNumber}` });
    },
    getVehicleType(id) {
      var vehicles = this.vehicleTypes.filter(v => v.id == id);
      if (vehicles.length === 0) return "Okänd fordonstyp"
      return vehicles[0].name;
    },
    getFuelType(id) {
      var fuels = this.fuelTypes.filter(v => v.id == id);
      if (fuels.length === 0) return "Okänd bränsletyp"
      return fuels[0].name;
    },
  }
}
</script>

<style>

</style>
